import { ITheme } from "../containers/Theme/Common/Theme";
import { showError } from "../utils/errorHandler";
import { isEmptyObject, isObject } from "./utils";

export const theme = (theme: ITheme): boolean => {
  if (!isObject(theme) || isEmptyObject(theme)) {
    showError(
      "Invalid theme. Please provide a plain JavaScript object that is not empty."
    );
    return false;
  }

  return true;
};
